export const safeJsonParse = (jsonString, handleNAN = false) => {
  try {
    return JSON.parse(
      handleNAN ? jsonString.replace(/\bNaN\b/g, "null") : jsonString
    );
  } catch (e) {
    return jsonString;
  }
};
